import { toDate } from 'date-fns-tz';

export default function parseDate(dateLike: Date | string | number) {
    return toDate(dateLike, { timeZone: 'UTC' });
}
